import * as React from "react";
const SvgFiRrBellSchool = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bell-school_svg__a)">
      <path
        fill="#062147"
        d="M10 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m14 2a14.27 14.27 0 0 1-11.484 13.952 2.95 2.95 0 0 1-2.431-.646A3.01 3.01 0 0 1 9 20.99v-1.041a10 10 0 1 1 9.382-15.394A1.003 1.003 0 1 1 16.7 5.646a8 8 0 1 0 0 8.708 1.003 1.003 0 0 1 1.384-.293 1 1 0 0 1 .293 1.384A9.96 9.96 0 0 1 11 19.937v1.053a1.02 1.02 0 0 0 .738.977c.137.037.28.043.42.017a12.19 12.19 0 0 0 9.47-9.053A3 3 0 0 1 21 13a3 3 0 1 1 3-3m-2 0a1 1 0 1 0-2 0 1 1 0 0 0 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bell-school_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBellSchool;
